import React from 'react';
import FormSuccessConfirmation from 'src/components/FormSuccessConfirmation/FormSuccessConfirmation';
import Button from 'src/components/Button';
import FontAwesomeIcon from 'src/components/Icon';
import './key-handoff-success.scss';

interface KeyHandoffSuccessProps {
  onBackToSuite: () => void;
}

const KeyHandoffSuccess = ({ onBackToSuite }: KeyHandoffSuccessProps) => {
  return (
    <div className="key-handoff-success">
      <FormSuccessConfirmation
        illustration={
          <FontAwesomeIcon glyph="check-circle" weight="solid" size="large" />
        }
        heading="Key pickup complete"
      >
        The key pickup for this unit has been completed.
      </FormSuccessConfirmation>
      <Button
        color="teal"
        size="small"
        label="Back to suite"
        onClick={onBackToSuite}
      />
    </div>
  );
};

export default KeyHandoffSuccess;